import SceneController from './SceneController'
import utils from './WorldUtils'
import $ from 'jquery'
const THREE = window.THREE

const RooftopController = function (chapterIndex, data, $bus, filename, cursor, zIndex, minZ) {
  this.init(chapterIndex, data, $bus, filename, cursor, zIndex, minZ)
}

RooftopController.prototype = Object.assign(
  {},
  SceneController.prototype,
  {
    init (chapterIndex, data, $bus, filename, cursor, zIndex, minZ) {
      SceneController.prototype.init.bind(this)(chapterIndex, data, $bus)
      this.filename = filename
      this.cursor = cursor
      this.zIndex = zIndex
      this.positionFactor = -0.1
      this.minZ = minZ
    },
    enable () {
      this.addEventListeners()
    },
    getZIndex () {
      return this.zIndex
    },
    getFilename () {
      return this.filename
    },
    traverseObject (object, customProperties) {
      utils.traverseObject(object, customProperties, this, this.cursor)
    },
    replaceOverlayTexts (index, scene) {
      const text = this.data[index]
      this.cssElements = {}
      this.text3DObjects = {}
      if (text && text.intro) {
        this.cssElements.intro = document.createElement('div')
        this.cssElements.intro.innerHTML = `<h1 class="popup intro">${text.intro}</h1>`
        // if (text.intro.width) {
        // }
        let targetObject = this.intros[index]
        targetObject.geometry.computeBoundingBox()
        let bbox = targetObject.geometry.boundingBox
        let width = utils.unitsToPixels(bbox.max.x - bbox.min.x)
        $(this.cssElements.intro).find('.popup.intro').css('maxWidth', width)
        if (targetObject.textColor) {
          $(this.cssElements.intro).find('.popup.intro').css('color', targetObject.textColor)
          if (targetObject.textColor === 'black') {
            $(this.cssElements.intro).find('.popup.intro').css('fontWeight', 400)
          }
        }
        if (targetObject.fontWeight) {
          $(this.cssElements.intro).find('.popup.intro').css('fontWeight', targetObject.fontWeight)
        }
        this.text3DObjects.intro = new THREE.CSS3DObject(this.cssElements.intro)
        let introPosition = utils.getCenterPoint(targetObject)
        this.text3DObjects.intro.position.set(
          introPosition.x,
          introPosition.y,
          introPosition.z
        )
        this.text3DObjects.intro.scale.set(0.03, 0.03, 0.03)
        scene.add(this.text3DObjects.intro)
      }
    }
  }
)

export default RooftopController



// WEBPACK FOOTER //
// ./src/world/RooftopController.js